export const Breakpoint = {
  mobile: 425,
  tablet: 768,
  laptop: 1024,
  desktop: 1600
};

export const Device = {
  downMobile: `@media (max-width: ${Breakpoint.mobile - 1}px)`,
  downTablet: `@media (max-width: ${Breakpoint.tablet - 1}px)`,
  downLaptop: `@media (max-width: ${Breakpoint.laptop - 1}px)`,
  downDesktop: `@media (max-width: ${Breakpoint.desktop - 1}px)`,
  upLaptop: `@media (min-width: ${Breakpoint.laptop}px)`,
  upDesktop: `@media (min-width: ${Breakpoint.desktop}px)`
};
